<template>
  <v-row class="fill-height">
    <v-col>
      <v-card>
        <v-card-title>
          <!--<v-icon
                        @click="pushRouteToView('products')"
                        style="cursor: pointer"
                        left
                    >
                        mdi-arrow-left
                    </v-icon>-->
          <span v-if="id">
            <v-btn
              small
              @click="pushRouteToView('product')"
              class="mr-4 btn-back"
            >
              <v-icon> mdi-arrow-left </v-icon>
              Voltar
            </v-btn>
          </span>
          <span v-else>
            <v-btn
              small
              @click="pushRouteToView('products')"
              class="mr-4 btn-back"
            >
              <v-icon> mdi-arrow-left </v-icon>
              Voltar
            </v-btn>
          </span>

          <v-icon class="mr-3">mdi-shopping</v-icon>
          <span v-if="id">Editar</span>
          <span v-else>Adicionar</span>&nbsp;Produto
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-form
            ref="formProduct"
            v-model="formIsValid"
            v-on:submit.prevent="productSubmit(product.id)"
          >
            <v-row>
              <v-col md="12" sm="12" xs="12" v-show="product.id">
                <v-text-field
                  v-model="product.code"
                  outlined
                  disabled
                  label="Código"
                  dense
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col md="8" sm="8" xs="8">
                <v-text-field
                  v-model="product.description"
                  outlined
                  :rules="textRules"
                  label="Descrição"
                  placeholder="Descrição do produto"
                  append-icon="mdi-format-align-justify"
                  dense
                  v-uppercase
                />
              </v-col>
              <v-col md="4" sm="4" xs="4">
                <v-select
                  v-model="product.classID"
                  :items="classes"
                  item-text="name"
                  item-value="id"
                  label="Classe"
                  :rules="textRules"
                  outlined
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" sm="12">
                <!--                                <v-autocomplete-->
                <!--                                    v-model="product.brandName"-->
                <!--                                    :items="brands"-->
                <!--                                    :loading="brandLoading"-->
                <!--                                    :search-input.sync="brandSearch"-->
                <!--                                    item-text="name"-->
                <!--                                    item-value="name"-->
                <!--                                    label="Escolha ou cadastre uma marca."-->
                <!--                                    placeholder="Comece a digitar para pesquisar"-->
                <!--                                    :rules="textRules"-->
                <!--                                    outlined-->
                <!--                                ></v-autocomplete>-->
                <v-combobox
                  v-model="product.brand"
                  :items="brands"
                  :loading="brandLoading"
                  :search-input.sync="brandSearch"
                  item-text="name"
                  item-value="name"
                  :return-object="false"
                  label="Escolha ou Cadastre uma Marca"
                  placeholder="Comece a Digitar para Pesquisar"
                  :rules="textRules"
                  outlined
                  dense
                  v-uppercase
                ></v-combobox>
              </v-col>
              <v-col md="6" sm="12">
                <v-select
                  v-model="product.supplierID"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  label="Fornecedor"
                  placeholder="Escolha um fornecedor."
                  :rules="textRules"
                  outlined
                  append-icon="mdi-factory"
                  dense
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="3" sm="6">
                <v-select
                  v-model.number="product.unitID"
                  :items="units"
                  item-text="name"
                  item-value="id"
                  label="Unidade de Estoque"
                  :rules="textRules"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  v-model="product.packageID"
                  :items="packages"
                  item-text="name"
                  item-value="id"
                  label="Tipos de Embalagem"
                  :rules="textRules"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  v-model="product.categoryID"
                  :items="productCategories"
                  item-text="name"
                  item-value="id"
                  label="Categorias"
                  :rules="textRules"
                  outlined
                  dense
                ></v-select>
              </v-col>

              <v-col md="3" sm="12">
                <v-text-field
                  v-model="product.barCode"
                  outlined
                  
                  label="Código de Barras"
                  v-mask="['#############']"
                  append-icon="mdi-barcode"
                  dense
                />
              </v-col>
              <v-col md="3" sm="12">
                <v-text-field
                  v-model="product.manufacturerCode"
                  outlined
                  label="Código do Fabricante"
                  append-icon="mdi-numeric"
                  dense
                />
              </v-col>

              <v-col md="3" sm="12">
                <!--                                <v-text-field-->
                <!--                                    v-model.number="product.minimumStock"-->
                <!--                                    outlined-->
                <!--                                    :rules="textRules"-->
                <!--                                    label="Estoque mínimo."-->
                <!--                                />-->

                <number-input
                  outlined
                  v-model.number="product.minimumStock"
                  label="Estoque Mínimo"
                  placeholder="Estoque Mínimo de Produtos"
                  :options="optionsNumber"
                  append-icon="mdi-arrow-down-box"
                  dense
                >
                </number-input>
              </v-col>
              <v-col md="3" sm="12">
                <!--                                <v-text-field-->
                <!--                                    v-model.number="product.maximumStock"-->
                <!--                                    outlined-->
                <!--                                    :rules="textRules"-->
                <!--                                    label="Estoque maximo."-->
                <!--                                />-->

                <number-input
                  outlined
                  v-model.number="product.maximumStock"
                  label="Estoque Máximo"
                  placeholder="Estoque Máximo de Produtos"
                  :options="optionsNumber"
                  append-icon="mdi-arrow-up-box"
                  dense
                >
                </number-input>
              </v-col>
              <v-col md="3" sm="12">
                <!--                                <v-text-field-->
                <!--                                    v-model.number="product.quantity"-->
                <!--                                    outlined-->
                <!--                                    :rules="textRules"-->
                <!--                                    label="Quantidade."-->
                <!--                                />-->
                <number-input
                  outlined
                  v-model.number="product.quantity"
                  :rules="textRules"
                  label="Quantidade"
                  placeholder="Quantidade de produtos."
                  :options="optionsNumber"
                  append-icon="mdi-format-list-numbered"
                  dense
                >
                </number-input>
              </v-col>
              <v-col md="3" sm="12">
                <v-select
                  v-model="product.commissionBM"
                  :items="commission"
                  item-text="name"
                  item-value="value"
                  label="Comissionar BM"
                  placeholder="Escolha uma Opção"
                  :rules="commissionBMRules"
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col md="3" sm="12">
                <!--                                <v-text-field-->
                <!--                                    v-model="product.costPrice"-->
                <!--                                    outlined-->
                <!--                                    :rules="textRules"-->
                <!--                                    label="Preço de custo"-->
                <!--                                />-->

                <number-input
                  label="Preço de Custo"
                  v-model.number="product.costPrice"
                  placeholder="Preço de Custo do Produto"
                  :rules="textRules"
                  outlined
                  :options="optionsMoney"
                  append-icon="mdi-currency-usd"
                  dense
                ></number-input>
              </v-col>
              <v-col md="3" sm="12">
                <number-input
                  outlined
                  v-model.number="product.salesPrice"
                  :search-input.sync="salesPrice"
                  :rules="textRules"
                  label="Preço de Venda"
                  placeholder="Valor de Venda do Produto"
                  :options="optionsMoney"
                  @input="salesPriceUpdate"
                  append-icon="mdi-currency-usd"
                  dense
                >
                </number-input>
              </v-col>

              <v-col md="3" sm="12">
                <!--                                <v-text-field-->
                <!--                                    v-model="product.salesPrice"-->
                <!--                                    :search-input.sync="salesPrice"-->
                <!--                                    outlined-->
                <!--                                    :rules="textRules"-->
                <!--                                    label="Margem de lucro"-->
                <!--                                />-->

                <number-input
                  outlined
                  v-model.number="product.profitMargin"
                  :rules="textRules"
                  label="Margem de Lucro"
                  placeholder="Informe a Porcentagem"
                  append-icon="mdi-percent"
                  dense
                  :options="optionsCommission"
                  disabled
                >
                </number-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="12" class="text-right">
                <v-btn
                  color="error"
                  v-if="product.id"
                  class="mr-4"
                  @click="reset"
                >
                  <v-icon>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <!--<v-btn
                                    color="error"
                                    v-else
                                    class="mr-4"
                                    @click="reset"
                                >
                                    <v-icon>mdi-eraser</v-icon>
                                    Limpar
                                </v-btn>-->
                <v-btn
                  dark
                  v-else
                  class="mr-4 btn-cancel"
                  @click="pushRouteToView('products')"
                >
                  <v-icon>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-btn type="submit" class="btn-save">
                  <v-icon left v-if="product.id">mdi-content-save</v-icon>
                  <v-icon left v-else>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mask } from "vue-the-mask";
import store from "@/store";
import NumberInput from "@/components/NumberInput";

import { mapGetters } from "vuex";

import { SUPPLIERS_GET } from "@/store/actions/supplier.type";
import {
  PRODUCT_RESET_STATE,
  SET_BRANDS,
} from "@/store/mutations/product.type";
import {
  PARAMETERS_GET,
  PRODUCT_CREATE,
  PRODUCT_UPDATE,
  PRODUCT_GET,
  PRODUCT_BRAND_SEARCH,
} from "@/store/actions/product.type";

export default {
  name: "EditCreateProduct",
  directives: { mask },
  props: {
    id: {
      default: 0,
      type: Number,
      required: false,
    },
  },

  components: { NumberInput },
  async beforeRouteUpdate(to, from, next) {
    // Reset state if user goes from /editor/:id to /editor
    // The component is not recreated so we use to hook to reset the state.
    await store.commit(PRODUCT_RESET_STATE);
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    await store.commit(PRODUCT_RESET_STATE);
    if (to.params.id !== undefined)
      await store.dispatch(PRODUCT_GET, to.params.id);
    await store.dispatch(PARAMETERS_GET);
    await store.dispatch(SUPPLIERS_GET);

    return next();
  },
  data: () => ({
    editCreateProduct: null,
    brandLoading: false,
    brandSearch: "",
    salesPrice: null,

    optionsMoney: {
      locale: "pt-BR",
      prefix: "R$:",
      length: 7,
      precision: 2,
    },

    optionsNumber: {
      locale: "pt-BR",
      prefix: "",
      length: 5,
      precision: 0,
    },

    optionsCommission: {
      locale: "pt-BR",
      prefix: "",
      length: 4,
      precision: 2,
    },

    items: [
      { value: 5, desc: "5 minutos" },
      { value: 10, desc: "10 minutos" },
      { value: 15, desc: "15 minutos" },
      { value: 30, desc: "30 minutos" },
      { value: 60, desc: "60 minutos" },
    ],
    commission: [
      { name: "Sim", value: true },
      { name: "Não", value: false },
    ],
    img: null,
    selectMaterialOK: "",
    formIsValid: false,
    textRules: [
      (v) => !!v || "Este campo é obrigatório",
      //v => v > 0 || "Esta campo deve ter um valor maior que zero."
    ],
    numberRules: [
      (v) => {
        // if (!v.trim()) return true;
        if (typeof v !== "undefined" && v !== null) {
          if (!isNaN(v) && v >= 0.0 && v <= 100) return true;
        }
        return "Informe um valor de 0 a 100";
      },
    ],

    fileRules: [
      (value) => !!value || "Campo obrigatório.",
      // value => !value || value.size < 2000000 || "A imagem tem que ter menos de  2 MB!",
    ],
    emailRules: [
      (v) => !!v || "E-mail é obrigatório",
      (value) => {
        if (typeof value !== "undefined" && value !== null) {
          if (value.length > 0) {
            const pattern =
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Informe um email válido";
          }
        }
        return false;
      },
    ],
    hourRules: [
      (v) => !!v || "Campo obrigatório",
      (value) => {
        if (typeof value !== "undefined" && value !== null) {
          if (value.length > 0) {
            const pattern = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/;
            return pattern.test(value) || "Informe um horário válido";
          }
        }
        return false;
      },
    ],
    telRules: [
      (v) => !!v || "Telefone é obrigatório",
      (value) => {
        if (typeof value !== "undefined" && value !== null) {
          if (value.length > 0) {
            const pattern = /(\(?\d{2}\)?\s)?(\d{4,5}-\d{4})$/;
            return pattern.test(value) || "Informe um telefone válido";
          }
        }
        return false;
      },
    ],
    commissionBMRules: [
      (v) => {
        if (v == null) return false;
        return true;
      },
    ],
  }),
  methods: {
    pushRouteToView(route) {
      this.$router.push({ name: route });
    },
    // async previewImage() {
    //     if (this.img) {
    //         const toBase64 = file => new Promise((resolve, reject) => {
    //             const reader = new FileReader();
    //             reader.readAsDataURL(file);
    //             reader.onload = () => resolve(reader.result);
    //             reader.onerror = error => reject(error);
    //         });
    //
    //         store.commit(SET_BM_IMAGE, await toBase64(this.img));
    //     }
    // },
    durationRule(v) {
      if (!v) {
        return "Este campo é obrigatório";
      }
      if (typeof v !== "undefined" && v !== null) {
        if (v % this.bm.serviceStepTime !== 0) {
          return "Este campo precisa ser múltiplo do fator de serviço";
        }
      }
      return true;
    },

    salesPriceUpdate() {
      let m =
        (this.product.salesPrice - this.product.costPrice) /
        this.product.salesPrice;
      this.product.profitMargin = (m.toFixed(4) * 100).toFixed(2);
    },

    permissionValue(permission) {
      let permLevel = this.bm.permissions.find((p) => p.id === permission);
      if (typeof permLevel !== "undefined") {
        return { id: permLevel.levelID };
      }
      return null;
    },

    passwordRule(pass) {
      if (!pass && this.id != 0) return true;
      return !!pass || "Este campo é obrigatório";
    },
    reset() {
      if (this.$route.params.id > 0) {
        this.$router.go(-1);
      } else {
        this.$refs.formProduct.resetValidation();
        store.commit(PRODUCT_RESET_STATE);
      }
    },

    productSubmit(id) {
      if (this.$refs.formProduct.validate()) {
        let action = id ? PRODUCT_UPDATE : PRODUCT_CREATE;
        this.inProgress = true;
        // this.bloqueiaEnvio = true;
        this.$store
          .dispatch(action)
          .then((response) => {
            this.inProgress = false;

            this.snackbar.snackbar = true;
            this.snackbar.color = "success";
            this.snackbar.text = "Salvo com sucesso";
            if (response.data.id) {
              this.$router.push({
                name: "product",
                params: { id: response.data.id },
              });
            } else {
              this.$router.push({
                name: "product",
                params: { id: id },
              });
            }
          })
          .catch(({ response }) => {
            this.inProgress = false;
            this.snackbar.snackbar = true;
            this.snackbar.color = "error";
            this.snackbar.text = "Erro ao salvar Produto.";
            // console.log(response.data);
            if (typeof response.data.message !== "undefined") {
              this.snackbar.text =
                "Erro ao salvar Produto: " + response.data.message;
            }
          });
      } else {
        this.snackbar.snackbar = true;
        this.snackbar.color = "error";
        this.snackbar.text = "Preencha o formulário corretamente";
      }
    },
  },
  mounted() {},
  computed: {
    // ...mapState({
    //   courses: state => state.
    // })

    ...mapGetters([
      "snackbar",
      "product",
      "classes",
      "packages",
      "units",
      "productCategories",
      "suppliers",
      "brands",
    ]),
  },
  watch: {
    brandSearch(val) {
      if (!val) {
        return;
      }
      if (val === "" || val.length < 2) {
        this.$store.commit(SET_BRANDS, []);
        return;
      }
      this.brandLoading = true;
      this.$store.dispatch(PRODUCT_BRAND_SEARCH, val);
      this.brandLoading = false;
    },
  },
};
</script>